import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { UPLOAD_FILE, GET_ERRORS } from "../../../../../actions/types";
import { Form, Button, Col, ButtonGroup, Row } from "react-bootstrap";
import { UploadFile } from "./../../../../../actions/ProductActions";
import BootstrapTable from 'react-bootstrap-table-next';
import services from "./../../../../../config/services";
import LoadingOverlay from 'react-loading-overlay';
import Snackbar from '@material-ui/core/Snackbar';
import 'react-widgets/dist/css/react-widgets.css';
import docs from "../../../../../config/docs";
import MuiAlert from '@material-ui/lab/Alert';
import React, { Component } from "react";
import { Info } from "@material-ui/icons";
import { IconButton } from "material-ui";
import { connect } from "react-redux";
import "./UploadProductFile.scss";
import Axios from "axios";

const URL_PRODUCTS_DOWNLOAD = process.env.REACT_APP_API_URL + services.productsDownload;
const URL = docs.docsUploadProducts;

const { SearchBar } = Search;
const columns = [{
	dataField: 'no_sap',
	text: 'No Sap'
}, {
	dataField: 'message',
	text: 'Mensaje'
}];


function customMatchFunc({ searchText, value, column, row }) {
	if (typeof value !== 'undefined') {
		return value.startsWith(searchText);
	}
	return false;
}

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class UploadProductFile extends Component {

	//----------------------EVENTS-----------------//
	constructor() {
		super();
		this.state = {
			activeLoader: false,
			showSnackBar: false,
			textSnackBar: '',
			severitySnackBar: 'success'
		};
		this.handleClose = this.handleClose.bind(this);
	}

	handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		this.setState({
			showSnackBar: false
		})
	};

	onUploadFile(event) {
		const inputFile = document.getElementById("input-file");
		const files = Array.from(inputFile.files)
		this.setState({ activeLoader: true });
		this.props.UploadFile(files[0]);
	}
	onDownloadLayout(event) {
		const d     = new Date();
		const files = JSON.parse(process.env.REACT_APP_FILES);
		const url   =  files.productTemplate + '?q=' + d.getTime();
		window.open(url, "_blank");
	}

	onDownloadDatabase = (event) => {
		this.setState({
			activeLoader: true
		});
		Axios.get(URL_PRODUCTS_DOWNLOAD, { responseType: 'arraybuffer',}).then((res) => {
			const url  = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement('a');
			link.href  = url;
			link.setAttribute('download', 'layout_productos.xlsx');
			document.body.appendChild(link);
			link.click();
			this.setState({
				activeLoader: false
			});
		}).catch(error => {
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'No se pudo descargar el archivo, por favor intentelo más tarde. ' + error.message,
				severitySnackBar: 'error',
			});
		});
	}

	componentDidUpdate(prev) {
		this.state.activeLoader = false

		if (this.props.actionType === UPLOAD_FILE && prev.actionType !== UPLOAD_FILE) {
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "El archivo se ha procesado correctamente.",
				severitySnackBar: 'success',
			});
			document.getElementById("input-file").value = "";
		}
		else if (this.props.actionType === GET_ERRORS && prev.actionType !== GET_ERRORS) {

			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: JSON.stringify(this.props.product_reducer.message),
				severitySnackBar: 'error',
			});
		}
	}

	redirectTo() {
		const newWindow = window.open(URL, '_blank', 'noopener,noreferrer')
		if (newWindow) newWindow.opener = null
	}

	render() {

		const { product_reducer } = this.props;
		if (!product_reducer || !product_reducer.data) {
			product_reducer.data = {};
			product_reducer.data.SuccesResponse = [];
			product_reducer.data.FailResponse = [];
		}

		return (
			<div className="main-content">
				<div className="malls-category-headers">
					Carga masiva de productos
					<IconButton
						size="small"
					>
						<Info onClick={() => this.redirectTo()} />
					</IconButton>
				</div>
				<Row>
					<Col xs={12} md={12} lg={6}>
						<Form>
							<Form.Group controlId="formBasicEmail">
								<Form.File
									id="input-file"
									accept=".xlsx"
									className="position-relative"
									required
									name="file"
									label=""
								/>
							</Form.Group>
							<Button variant="primary" type="button" onClick={this.onUploadFile.bind(this)}>
								Cargar
							</Button>
						</Form>
					</Col>
					<Col xs={12} md={12} lg={6} style={{ marginTop: "15px", textAlign: "right" }}>
						<ButtonGroup size="lg">
							<button onClick={this.onDownloadDatabase} className="buttonAdd">Descargar Cátalogo</button>
						</ButtonGroup>
					</Col>
				</Row>


				<Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: "35px" }} >
					<h4>Productos procesados</h4>
					{product_reducer &&
						product_reducer.data.SuccesResponse &&

						<ToolkitProvider
							keyField="id"
							data={product_reducer.data.SuccesResponse}
							columns={columns}
							search={{ customMatchFunc }}
						>
							{
								props => (
									<div style={{ textAlign: "left" }}>
										<SearchBar
											placeholder={"Buscar"}
											{...props.searchProps} />

										<BootstrapTable
											{...props.baseProps}
										/>
									</div>
								)
							}
						</ToolkitProvider>
					}
				</Col>
				<Col xs={12} sm={12} md={12} lg={12} style={{ marginTop: "35px" }} >
					<h4>Productos con error</h4>
					{product_reducer &&
						product_reducer.data.FailResponse &&

						<ToolkitProvider
							keyField="id"
							data={product_reducer.data.FailResponse}
							columns={columns}
							search={{ customMatchFunc }}
						>
							{
								props => (
									<div style={{ textAlign: "left" }}>
										<SearchBar
											placeholder={"Buscar"}
											{...props.searchProps} />

										<BootstrapTable
											{...props.baseProps}
										/>
									</div>
								)
							}
						</ToolkitProvider>
					}
				</Col>
				{
					<LoadingOverlay
						active={this.state.activeLoader}
						isVisible={this.state.activeLoader}
						spinner
						text='Esto puede tardar unos minutos'
						styles={{
							wrapper: {
								width: this.state.activeLoader ? '100%' : '0%',
								height: this.state.activeLoader ? '100%' : '0%',
								overflow: 'hidden',
							},
							overlay: (base) => ({
								...base,
								background: 'rgba(10, 10, 10, 0.7)'
							})
						}}>
					</LoadingOverlay>
				}
				{
					<Snackbar open={this.state.showSnackBar} autoHideDuration={4000} onClose={this.handleClose}>
						<Alert onClose={this.handleClose} severity={this.state.severitySnackBar}>
							{this.state.textSnackBar}
						</Alert>
					</Snackbar>
				}
			</div>
		)
	}

}

const mapStateToProps = state => ({
	product_reducer: state.product_reducer,
	actionType: state.product_reducer.actionType,
	errors: state.errors,
	success: state.success
});

export default connect(
	mapStateToProps,
	{
		UploadFile,
	}
)(UploadProductFile);
